/* ============================================================
   DWELL & CO — STICKY MOBILE "FILTER & SORT" BAR
   ------------------------------------------------------------
   Builds a floating Filter & Sort button that reveals when the
   shopper scrolls back UP a collection / search page on mobile,
   and hides while they scroll down. Tapping it opens the theme's
   native mobile filter drawer (.mobile-facets__wrapper), so all
   existing filtering, sorting and dimension sliders are reused —
   this file adds no new filter logic of its own.

   Paired with: assets/dwell-mobile-filter.css
   ============================================================ */
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 749px)';
  var SCROLL_DELTA = 4; // px of movement needed before we treat it as a direction change

  // Theme's own filter icon (snippets/icon-filter.liquid), inlined for a 1:1 match.
  var FILTER_ICON =
    '<svg class="icon icon-filter" width="24" height="24" viewBox="0 0 24 24" fill="none" ' +
    'xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
    '<path d="M12.75 16.125H3.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M20.25 16.125H15.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M6.75 7.875H3.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M20.25 7.875H9.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M9.75 5.625V10.125" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M15.75 18.375V13.875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function init() {
    // Only runs where the theme rendered a mobile filter trigger (collection / search).
    var wrapper = document.querySelector('.mobile-facets__wrapper');
    if (!wrapper) return;

    var summary = wrapper.querySelector('details > summary');
    var source = wrapper.querySelector('.mobile-facets__open');
    if (!summary || !source) return;

    // Don't build twice (e.g. theme editor re-renders).
    if (document.querySelector('.dwell-fbar')) return;

    // Reuse the theme's own label text (keeps wording + localization consistent).
    var srcLabel = source.querySelector('span:not(.count-bubble)');
    var labelText = (srcLabel && srcLabel.textContent.trim()) || 'Filter & Sort';

    var bar = document.createElement('div');
    bar.className = 'dwell-fbar';
    bar.setAttribute('aria-hidden', 'true');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'dwell-fbar__btn button button--primary';
    btn.setAttribute('aria-label', labelText);
    btn.innerHTML =
      FILTER_ICON +
      '<span class="dwell-fbar__label"></span>' +
      '<span class="dwell-fbar__count" hidden></span>';
    btn.querySelector('.dwell-fbar__label').textContent = labelText;

    bar.appendChild(btn);
    document.body.appendChild(bar);

    var countEl = btn.querySelector('.dwell-fbar__count');

    // --- Open the theme's real mobile filter/sort drawer -------------------
    btn.addEventListener('click', function () {
      summary.click();
    });

    // --- Keep the active-filter count in sync with the theme's button ------
    function syncCount() {
      var srcCount = source.querySelector('.count-bubble');
      var n = srcCount ? srcCount.textContent.trim() : '';
      if (n && n !== '0') {
        countEl.textContent = n;
        countEl.hidden = false;
      } else {
        countEl.textContent = '';
        countEl.hidden = true;
      }
    }
    syncCount();
    // facets.js rewrites .mobile-facets__open (incl. its count) on every AJAX update.
    try {
      new MutationObserver(syncCount).observe(source, {
        childList: true,
        subtree: true,
        characterData: true
      });
    } catch (e) { /* MutationObserver unsupported — count just won't live-update */ }

    // --- Reveal-on-scroll-up behaviour (mobile only) ----------------------
    var mq = window.matchMedia(MOBILE_QUERY);
    // Use the sticky header's STABLE layout height (offsetHeight), NOT its live
    // getBoundingClientRect(). On themes whose header reveals on scroll-up, the
    // rect is mid-animation while we read it and clamps to 0, which drops the bar
    // on top of the header. offsetHeight ignores the transform and stays constant.
    var headerEl = document.querySelector('.header-wrapper') || document.querySelector('.shopify-section-header');
    var lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var ticking = false;

    function headerHeight() {
      return headerEl ? headerEl.offsetHeight : 0;
    }

    function update() {
      ticking = false;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;

      if (!mq.matches) {                       // tablet / desktop — never show
        bar.classList.remove('is-visible');
        lastY = y;
        return;
      }

      var hh = headerHeight();
      bar.style.setProperty('--fbar-top', hh + 'px');

      // Is the theme's own inline filter button still on screen?
      var inlineStillVisible = source.getBoundingClientRect().bottom > hh + 4;
      var goingUp = y < lastY - SCROLL_DELTA;
      var goingDown = y > lastY + SCROLL_DELTA;

      if (inlineStillVisible) {
        bar.classList.remove('is-visible');    // real button is right there — no need
      } else if (goingUp) {
        bar.classList.add('is-visible');       // scrolling up + real button gone -> reveal
      } else if (goingDown) {
        bar.classList.remove('is-visible');    // scrolling down -> get out of the way
      }
      // within the jitter delta: leave the current state as-is

      if (Math.abs(y - lastY) > SCROLL_DELTA) lastY = y;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    if (mq.addEventListener) {
      mq.addEventListener('change', update);
    } else if (mq.addListener) {
      mq.addListener(update);
    }

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Rebuild if the collection section is reloaded inside the theme editor.
  document.addEventListener('shopify:section:load', function () {
    if (!document.querySelector('.dwell-fbar')) init();
  });
})();
